import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=1f0041e2&scoped=true&"
import script from "./FlipBook.vue?vue&type=script&lang=js&"
export * from "./FlipBook.vue?vue&type=script&lang=js&"
import style0 from "./FlipBook.vue?vue&type=style&index=0&id=1f0041e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0041e2",
  null
  
)

export default component.exports